import PageTitle from '../components/PageTitle';
import PageContent from '../components/PageContent';

export default function NotFound() {
    return (<>
      <PageTitle>404 Page Not Found</PageTitle>
      <PageContent>Sorry, we couldn't find what you were looking for.</PageContent>
    </>);
}